module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Atlanta, Georgia")])]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Two weeks later")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“A")])])])]), _vm._v("re you ever going to speak to me again?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena lifted her gaze from the file she’d been reading to the man standing at the door of her office.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He sure knew how to fill a doorway. And he always made her heart do a funny little lurching thing that she hated and denied each time she saw him. His shaggy honey brown hair and gold-green eyes gave him the look of some sort of modern-day pirate but the precisely tailored lightweight navy suit he wore today gave him the look of a corporate raider. Selena knew he was neither of those things.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was worse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice pushed off the doorjamb and settled into a squeaky old chair across from her battered metal desk. Loosening his silk tie, he said, “Selena, it’s been a couple of weeks now. You don’t call, you don’t write. You’re breaking my heart here.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Selena slammed the file into a folder and shoved it ")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("in the drawer of the old desk. The drawer stuck, so she tried slamming it again, pretending it was Brice Whelan’s head instead. The drawer squeaked in protest while she flushed a mortified pink all the way down to her toes. She wouldn’t give him the satisfaction of seeing her have a hissy fit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("She didn’t have to. He got up and with one deft whack, shut the drawer tight then settled on the edge of her desk to stare down at her, the crisp crease of his pants every bit as edgy as the tension slicing through her stomach.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“You need some stress management, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cara.")])]), _vm._v("”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“What I need,” Selena said, tired and ready to go home to her quaint Midtown apartment and a nice bath followed by a cup of hot herbal tea, “is for you to leave. Now.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“You can’t stay mad at me forever,” he said, not moving. “It’s me, Brice, remember? I’m just too lovable for you to stay angry. And I’m not leaving until you smile at least. You’ve such a pretty smile, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cara.")])]), _vm._v("”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Selena’s breath grabbed onto her rib cage, searching for release. He was too close. Which meant she was trapped since he was between the door and her. And that was the way Brice always made her feel—trapped in the intensity of his eyes, in the hold of his innate code of honor. Brice was too forceful, too "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("unwavering")])]), _vm._v(" for her. Just to prove he couldn’t get to her, she gave him a brutal frown. “Go away.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("He held his hands out, palms up, his big signet ring that bore the Whelan family fleur-de-lis crest dazzling her with flashes of gold. “I had to do it. You know that. Your father—”")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My father is still trying to control me, only this time he went too far. I called you down to Día Belo to help me solve the problem, not bring me home. His command for you to do that was the last straw.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He cares about you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, I know that. But he also hovers over me much in the same way you’re doing right now. And I’d really like you to just leave so I can go home. I’ve had a horrible day and I just want some peace and quiet and maybe a sappy movie on the cable channel.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How about coming to my house for dinner with me instead?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena let that idea slide over her like warm rain dripping off a rhododendron leaf and for just a second, considered it with a full intensity—candlelight, soft classical music, the comfort of Brice’s loyal considerate staff at her beck and call. But then she snapped out of that daydream. “What part of ‘peace and quiet’ did you miss, Brice? I don’t want to have dinner with you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He put a hand to his heart. “‘Fate slew him, but he did not drop.’”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Emily Dickinson—her favorite. “And don’t start reciting poetry to me. That won’t work either.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d play dead before she’d admit that she loved it when Brice quoted poetry to her—it was just the Irish accent, nothing more, that made those moments so special. But then, there were a lot of things about her old college friend that Selena didn’t want to acknowledge. Especially now, after he’d betrayed her trust by forcing her to leave the village in northern Argentina where she’d worked for more than two years.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("He stood, looking exasperated, staring down at her ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("with those lion-like eyes imploring her, his silence shouting more than his poetry ever could. “You have to forgive me sometime, you know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Selena put her head in her hands. “If you’ll just let me go home, I’ll consider it.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He huffed a sigh at that. “How "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("are")])]), _vm._v(" things, now that you’re back here at the clinic?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("She let out a dry chuckle, not daring to answer that with the whole truth. “Do you actually care?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He bent his head, his eyes slanting up toward her. “Of course I do, darlin’.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("She lifted a hand in the air. “Well, then I’ll tell you. Mrs. Parker has diabetes but she can’t afford her medication and the closest hospital won’t honor her insurance but we can’t get her on Medicaid—too much red tape to explain. And I had to call in reinforcements this morning because there’s a nasty spring virus going around this neighborhood and…a woman died right here in one of the exam rooms from a heart attack before we could get a transport to the hospital. She was taking the heart medication Dr. Jarrell prescribed—so we don’t know yet what happened with that. The first responders don’t have us on their priority list.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Before she could let out a sigh, he had her up and in his arms. “That does it then. You need nourishment. You’re coming home with me.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Selena had to work hard to hide her breathlessness. “I am not.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Yes, you are, too.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("She retracted herself, the warmth, the nearness of him, too much for her to handle on this rainy Friday af")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("ternoon. “No, Brice. You can’t fix things this time. We’re not in college anymore. And this isn’t a broken window or a flat tire or you rescuing me from my ex-boyfriend. You forced me to leave a place that I love, to leave the people that I love, and come back home to…to even more despair and sickness.” Whirling to grab her battered leather tote bag, she shook her head then hurried to the door. “You can’t fix this. So just go away.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Brice never listened to reason. It was his shortcoming, his downfall. He was too stubborn for his own good, really. Or, as his dear deceased grandmum used to say—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("bómánta")])]), _vm._v("—stupid. If he were a smart man, he’d do as Selena had asked. He’d just leave.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("But he wasn’t that smart. Not when it came to this particular woman. He’d known her since they were both young students, since the day he’d started college in a new city in a new country and was terrified down to his knickers, so to speak. And when it came to Selena Carter, or rather when it came to keeping Selena out of trouble, he was still terrified.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("For her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("So instead of going away as she had requested, he marched after her and took her by the arm again. “I might not be able to fix this situation so you can go back to Argentina, but I can fix you a decent meal. Or at least, someone at my house can. So don’t argue with me on this. Selena?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("She whirled, the scent of jasmine and sweet pea floating around her, her expression sharp-edged and full of resentment. “You, of all people, should understand how I feel. I didn’t want to come back here. I ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("wanted to stay in Día Belo because I made a commitment to those villagers and because I cared about them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Brice lowered his head, his whisper just for her. “And you, of all people, should know that I could not leave you down there in danger. It’s a matter of honor.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Hitching her tote onto her shoulder, she grabbed a pile of files off a hallway table and headed for the double front doors of the inner-city clinic known as Haven Center. “Yes, right. CHAIM honor. I know all about that. Remember, I’ve lived it and breathed it since birth. My father’s honor, your honor—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“The Lord’s honor,” Brice said, fighting to keep from grabbing her arm again. “C’mere.” Reaching for the files, he shifted them to his other arm as he guided her toward the door. “We try to do God’s work. You know that. And I couldn’t let you stay down there after—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“After those cutthroat smugglers killed my best friend and a good doctor, after they murdered Diego before I could help him? I watched them raid my clinic, Brice, while I cowered in the trees. Is that why you forced me to leave?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Well, yes, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cara.")])]), _vm._v(" That was certainly enough reason for me to come and fetch you home.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Fetch")])]), _vm._v(" me home?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She marched up the hallway, locking doors and telling workers to call it a day. “You certainly did fetch me home, all right. You practically kidnapped me.” Turning at the intricate doors of what had once been a church school and now served as the hub of this underprivileged inner-city suburb, she gave him a look that would trouble his dreams, her violet-blue eyes so big and luminous Brice’s heart crumbled like zapped stardust right at her feet.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They needed me,” she continued. “And I needed them. Someone should have protected those villagers, too. But no, we left them to be slaughtered.” Poking at his cotton shirt with a finger, she gave him a disgusted, disgraced look. “You took me and left them. And that’s what I can’t forgive. Or maybe I just can’t forgive myself for not confronting those thugs in the first place.” Grabbing back her files, she turned and stalked out the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The sting of her anger hit Brice with as much force as the damp spring humidity on the warm Atlanta streets. A quick spring shower had assaulted the city earlier, but the rain had stopped, leaving everything steamy and soaked. Searching, he saw her heading toward her hybrid mini SUV, her long golden-red ponytail set swinging with her frustration, her lightweight white button-up sweater sweeping away from her slender body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I guess that means she’s not coming home with me,” he mumbled. Selena, you do my head in, you know that?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He almost walked away, but he looked back up as she hit the remote key to open the SUV. When nothing happened, she hit the key again, then frowned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice stood frozen by the door of the Haven Center, his instincts ramping up, his muscles clenching. Something wasn’t right.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena stepped toward the car, still clicking the remote. Again, nothing happened. Her aggravated groan echoed down the street as she continued to hit the remote lock attached to her key chain. Finally, she looked up the street toward Brice, a determined frown on her face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Selena?”")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice hurried toward her, a pulse booming inside his temple. “Selena?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Leave me alone, Brice! This thing hasn’t worked right since I bought the car before I left for Argentina. So much for going green.” Intent on finding out why her car wouldn’t unlock, she reached toward the door, her fingers brushing against the lock button.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then Brice smelled it—a strong scent of gasoline and oil. He screamed her name again, then sprinted toward her and grabbed her from behind, lifting her up as he ran with all his might away from the car. About thirty feet away, he pushed her down onto the sidewalk, knocking her files all over the concrete, his body shielding hers as he tried to cover her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Seconds later, the explosion hit and the inside of Selena’s car became an inferno of molten-hot metal and chrome.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His voice was close to her, but the buzz inside her ears made it sound so far away. “You’re bleeding.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena looked up at the man holding her, her breath coming in deep, slashing gulps. “So are you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tried to sit up, tried to touch a finger to the scratch running across Brice’s cheekbone. But his hand on hers brought her back down. “Don’t move, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cara.")])]), _vm._v(" Let me make sure you’re in one piece.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m fine,” she said, his nearness as heated as the fire from the burning vehicle. Pushing at him, she managed to shift away. “What happened?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice sat her up against the clinic wall as people came running out of nearby buildings. “Your car exploded.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“But…why?” Then she looked up at him and saw it ")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("there on his face. “Oh, no. Don’t tell me. This can’t have anything to do with Argentina, with La Casa de Dios?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("The grim set of Brice’s mouth told her he certainly believed it did. La Casa de Dios—the house of God—was what the locals had called the clinic where she lived and worked. “I told you these were very dangerous people, luv. If you’d gotten in that car—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Selena pushed up the wall. “No. I don’t believe you. My key pad didn’t work. Something malfunctioned inside the vehicle. A spark—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Brice squatted in front of her, blood running down his face. “A bomb, Selena. A bomb happened inside that car, or at least underneath the car. You smelled the fumes, didn’t you? I don’t know what went wrong—maybe they weren’t as expert as they thought or maybe their timer wasn’t set correctly. But your key pad messing up saved you. It went off before you cranked it. Before you got inside—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Selena took in the scene, realizing the magnitude of what he was saying. Her car was totaled, a burning heap of gas fumes and scorched metal and chrome. Thank goodness no other cars or people had been nearby. Not many ventured on this street this late in the day, so no one else had been hurt.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("And she was still alive. And Brice. Brice was still alive. She thanked God for that.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("He held his cell phone while he looked up and down the street. Sirens sounded in the distance. “Listen, I called 911 but we don’t have much time. We have to get you away.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Away from what?” she asked, her thoughts all jumbled up like mixed wires.")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Away…before the newspeople get here. Your face doesn’t need to be plastered all over this city. They’ll try to come after you again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But if they know where I am already—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We don’t need to give them any more firsthand information, though, do we, luv?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A clinic worker came running out then. “Selena, are you all right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice lifted her up. “She needs to be checked out. We don’t want her going into shock.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The worker, whose nametag said Meg, looked frantic. “Dr. Jarrell left early for an out-of-town meeting, but I can call him back.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena slapped at Brice’s hand. “I’m fine. I just want to go home.” But her legs trembled like twigs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not just yet,” Brice said. His voice sounded far away, vacuumed, while his arms around her became a source of strength. “Meg, take her inside. I’ll talk to the police and explain what happened and then I’ll be in. They’ll want statements from Selena and any other witnesses, but I’m going to try and deal with them first. Lock the doors and do not open them unless you see my face.” When she didn’t answer, Brice leaned close. “Meg, this wasn’t an accident, understand?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Meg bobbed her head, her dark eyes going wide. “I hear you, Mr. Whelan. Mercy, what’s this old world coming to—a car exploding right here on the street.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Selena had to agree with her friend and coworker. Maybe this had just been some sort of random neighborhood retaliation. Maybe they’d gotten the wrong car. “Brice, are you sure?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Brice held her close, wiping smut and grime from her ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("bloody face. “Don’t argue with me. This is why I had to get you out of that village. They know you didn’t die in that attack and now they’ve found you. It’s not safe in Día Belo.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“And this place is?” she retorted.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("He couldn’t answer that, so he dropped his hand and motioned for Meg to take her. Then he turned to go and talk to the two Atlanta police officers stepping out of a patrol car. Behind them, an ambulance and two fire trucks pulled to a skidding halt.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("But when Selena looked back, Brice had his hands braced on his hips and he was watching her all the way to the door. And for the first time since she’d known him, she saw something there in his eyes that she’d never seen before.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Uncertainty and fear—for her.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fba81194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/codeofhonor_ch01.vue
// module id = 84
// module chunks = 0